import { asset, getBasePath } from "./lib/base.js";

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // Only register against built sw.js (present after `npm run build` / preview / deploy)
  try {
    const swUrl = asset("sw.js");
    const probe = await fetch(swUrl, { method: "HEAD" }).catch(() => null);
    if (!probe?.ok) return;
    await navigator.serviceWorker.register(swUrl, { scope: getBasePath() });
  } catch {
    /* optional in vite dev */
  }
}
